import { postData, getData } from './ApiSettings';

export const createSaleOrder = async (orderData) => {
  try {
    // Generate order number
    const orderNumber = `V${Date.now()}`;
    
    // Prepare order data
    const saleOrderData = {
      order_number: orderNumber,
      user: orderData.userId,
      user_details: orderData.userDetails,
      items: orderData.items.map(item => ({
        product_id: item.product.id,
        product_document_id: item.product.documentId,
        product_title: item.product.title,
        quantity: item.quantity,
        total_quantity: item.totalQuantity,
        unit_price: item.price,
        total_price: item.price * item.quantity,
        is_bulk: item.isBulk,
        bulk_quantity: item.isBulk ? item.product.bulk_quantity : null
      })),
      subtotal: orderData.subtotal,
      delivery_price: orderData.delivery.price,
      discount_amount: orderData.coupon ? orderData.coupon.discount : 0,
      total: orderData.totalAmount,
      order_status: 'pending',
      payment_status: 'pending',
      delivery_method: orderData.delivery.method,
      delivery_details: orderData.delivery.colissimo
        ? { colissimo: orderData.delivery.colissimo }
        : null,
      relay_point: orderData.relayPoint,
      coupon: orderData.coupon,
      comments: orderData.comments
    };

    const response = await postData('/sale-orders', { data: saleOrderData });
    
    if (response.data?.data?.id) {
      return {
        success: true,
        orderId: response.data.data.id,
        documentId: response.data.data.documentId,
        orderNumber: orderNumber
      };
    } else {
      throw new Error('Invalid response from server');
    }
  } catch (error) {
    console.error('Error creating sale order:', error);
    return {
      success: false,
      error: error.response?.data?.error?.message || error.message || 'Failed to create order'
    };
  }
};

export const getSaleOrderByDocumentId = async (documentId) => {
  try {
    const response = await getData(`/sale-orders?filters[documentId][$eq]=${documentId}&populate=*`);
    return response.data.data[0] || null;
  } catch (error) {
    console.error('Error fetching sale order:', error);
    return null;
  }
};

export const createSalePaymentLink = async (paymentData) => {
  try {
    const response = await postData('/stripe/create-sale-payment', {
      data: {
        orderId: paymentData.orderId,
        documentId: paymentData.documentId,
        amount: paymentData.totalAmount,
        customerEmail: paymentData.customerEmail,
        customerName: `${paymentData.firstName} ${paymentData.lastName}`
      }
    });

    if (response.data?.data?.url) {
      return {
        success: true,
        url: response.data.data.url
      };
    } else {
      throw new Error('Invalid response from payment service');
    }
  } catch (error) {
    console.error('Error creating sale payment link:', error);
    throw new Error(error.response?.data?.error?.message || 'Failed to create payment link');
  }
};

export const verifySalePayment = async (sessionId, documentId) => {
  try {
    const response = await postData('/stripe/verify-sale-payment', {
      data: {
        sessionId,
        document_id: documentId
      }
    });

    return response.data.data;
  } catch (error) {
    console.error('Error verifying sale payment:', error);
    throw new Error(error.response?.data?.error?.message || 'Payment verification failed');
  }
};